import React from 'react';
import { useSelector } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import ProfileSignIn from '../ProfileSignIn';
import './SignInLayoutV2.css';

export const SignInLayoutV2 = (props) => {
  const { isGifting } = props;

  const user = useSelector((s) => s.user);
  const { bango, isSpecialPromo } = useSelector((s) => s.integrations);

  const getTitle = () => {
    if (isGifting) {
      return 'Sign In To Redeem';
    } else if (bango.subscriptionId) {
      return 'Sign in';
    }
    return 'Sign in to watch';
  };
  const title = getTitle();

  return (
    <CenterFrameLayout
      customClass={`${isGifting ? 'giftCardSignIn' : 'signInLayout'}`}
      noPanel
      title={title}
      showLoader={user.isFetching}
    >
      <div className="signIn">
        <div className="panel profile">
          <div className="panelWrapper">
            <ProfileSignIn {...props} bango={bango} isSpecialPromo={isSpecialPromo} user={user} />
          </div>
        </div>
      </div>
    </CenterFrameLayout>
  );
};
